import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { I18nDomainCategoryComponent } from '@domains/job/i18n-domain-category/i18n-domain-category/i18n-domain-category.component';

@NgModule({
  imports: [CommonModule],
  declarations: [I18nDomainCategoryComponent],
  exports: [I18nDomainCategoryComponent],
})
export class I18nDomainCategoryModule {}
